import { HobgoblinDatabase } from "@/lib/db";
import { createDatabaseBindings } from "@indietabletop/appkit";

export const database = new HobgoblinDatabase();

// Expose on window to make it easier to debug IndexedDB
Object.assign(window, { hobgoblin: database });

export const { DatabaseProvider, useDatabase, useDatabaseOpenRequest, useQuery } =
  createDatabaseBindings(database);
